import { Environment } from '@nimmsta/ng-commons-lib';

export const environment = {
  production: true,
  environment: Environment.PROD,
  apiUrls: {
    b2b: 'https://backend.b2b-prod.nimmsta.com',
    workflow: 'https://backend.cloud.nimmsta.com',
    configurations: 'https://backend.configurator.nimmsta.com',
    auth: 'https://auth.nimmsta.com',
  },
  applicationUrls: {
    configurations: 'https://configurator.nimmsta.com',
    workflow: 'https://cloud.nimmsta.com',
    documentation: 'https://docs.nimmsta.com/platform',
  },
  defaultPageSize: 20,
  defaultPageSizeOptions: [10, 20, 50, 100],
  ORG_ID_KEY: 'org_id',
  ROLE_KEY: 'role',
  USER_KEY: 'user_object',
  IMPERSONATION_KEY: 'impersonation_data',
  IMPERSONATION_BROADCAST_CHANNEL_NAME: 'channel-impersonation-data',
  PRODUCT_FRUITS_KEY: 'rlwauFm8Wb7d9gSD',
  documentation1Url: 'https://docs.nimmsta.com/platform/',
  documentation2Url: 'https://docs.nimmsta.com',
  defaultConfigurationVersion: 7,

  keycloakUrl: 'https://auth.nimmsta.com',
  keycloakRealm: 'productivity-cloud',
  keycloakClientId: 'platform',

  discoveryDocument: 'https://discovery.nimmsta.com/index.json',

  androidAppSoftwareId: '17f85f34-1cab-480a-bc17-8050ec26f8d4',
};
